import moment from 'moment';
import { axios } from "../connection/ConnectionHandler";
import { createCrudActions } from '../utils/crudGenerator';

const formatEquipments = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
        lastMaintenanceDate: item.lastMaintenanceDate ? moment(item.lastMaintenanceDate) : null,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchEquipments,
    create: createEquipment,
    update: updateEquipment,
    delete: deleteEquipments
} = createCrudActions('EQUIPMENT', "Equipo", formatEquipments);

export const fetchEquipmentsByLocation = (locationId) => async (dispatch) => {
    try {
        const response = await axios.get(`equipment/location/${locationId}`);
        return response.data;
    } catch (err) {
        console.error(err);
        return [];
    }
};